export const dict = {
  "command.category.suggested": "Suggested",
  "command.category.view": "View",
  "command.category.project": "Project",
  "command.category.provider": "Provider",
  "command.category.server": "Server",
  "command.category.session": "Session",
  "command.category.theme": "Theme",
  "command.category.language": "Language",
  "command.category.file": "File",
  "command.category.context": "Context",
  "command.category.terminal": "Terminal",
  "command.category.model": "Model",
  "command.category.mcp": "MCP",
  "command.category.agent": "Agent",
  "command.category.permissions": "Permissions",
  "command.category.workspace": "Workspace",
  "command.category.settings": "Settings",

  "theme.scheme.system": "System",
  "theme.scheme.light": "Light",
  "theme.scheme.dark": "Dark",

  "command.sidebar.toggle": "Toggle sidebar",
  "command.project.open": "Open project",
  "command.project.previous": "Previous project",
  "command.project.next": "Next project",
  "command.provider.connect": "Connect integration",
  "command.server.switch": "Switch server",
  "command.settings.open": "Open settings",
  "command.session.previous": "Previous session",
  "command.session.next": "Next session",
  "command.session.previous.unseen": "Previous unread session",
  "command.session.next.unseen": "Next unread session",
  "command.session.archive": "Archive session",

  "command.palette": "Command palette",

  "command.theme.cycle": "Cycle theme",
  "command.theme.set": "Use theme: {{theme}}",
  "command.theme.scheme.cycle": "Cycle color scheme",
  "command.theme.scheme.set": "Use color scheme: {{scheme}}",

  "command.language.cycle": "Cycle language",
  "command.language.set": "Use language: {{language}}",

  "command.session.new": "New session",
  "project.start.dialog.title": "Open a project",
  "project.start.dialog.description": "Choose an OpenAnalyst suggested project or open a custom local folder.",
  "project.start.kicker": "Local project starters",
  "project.start.choice.title": "Start with the right workspace",
  "project.start.choice.description": "Create a ready OpenAnalyst project or bring in an existing folder.",
  "project.start.suggested.title": "OpenAnalyst suggested projects",
  "project.start.suggested.description": "Start from a ready workspace template.",
  "project.start.suggested.badge": "{{count}} starters",
  "project.start.suggested.action": "Explore starters",
  "project.start.templates.title": "Choose a starter project",
  "project.start.templates.description":
    "OpenAnalyst creates a local project folder with the starter structure already in place.",
  "project.start.custom.title": "Custom project",
  "project.start.custom.description": "Open an existing folder from your computer.",
  "project.start.custom.badge": "Local folder",
  "project.start.custom.action": "Browse folders",
  "project.start.back": "Back",
  "project.start.root.label": "Project location",
  "project.start.root.default": "~/Documents/OpenAnalyst Projects",
  "project.start.root.change": "Change folder",
  "project.start.root.choose": "Choose starter project folder",
  "project.start.createFailed.title": "Project could not be created",
  "project.start.createFailed.description":
    "OpenAnalyst could not create a project in {{path}}. Choose a different folder or allow folder access in macOS Settings. {{message}}",
  "project.start.createFailed.unsupportedTemplate":
    "This OpenAnalyst window does not recognize this starter template yet. Restart OpenAnalyst or update the desktop build, then try again. {{message}}",
  "project.start.new.title": "New project",
  "project.start.new.description": "Name a new project folder, or open one you already have.",
  "project.start.new.name": "Folder name",
  "project.start.new.placeholder": "OpenAnalyst Project",
  "project.start.new.nameInvalid": "Use a plain folder name — no slashes, and not starting with a dot.",
  "project.start.new.create.title": "Create Folder",
  "project.start.new.create.description": "Create it in {{path}} and open it.",
  "project.start.new.browse.title": "Browse Folder",
  "project.start.new.browse.description": "Open a folder you already have on this computer.",
  "project.start.new.template.title": "Custom Template",
  "project.start.new.template.description": "Choose the location and which apps this project starts with.",
  "project.start.new.creating": "Creating…",
  "project.template.title": "Custom Template",
  "project.template.description": "Pick the apps this project starts with. You can add the rest later.",
  "project.template.apps": "Apps",
  "project.template.appsHint": "{{count}} of {{total}} selected",
  "project.template.appsEmpty": "Select at least one app.",
  "project.template.appsFailed": "The app list could not be loaded. Create the project with every app instead.",
  "project.template.selectAll": "Select all",
  "project.template.clear": "Clear",
  "project.template.submit": "Create project",
  "project.hosted.create.title": "Create cloud project",
  "project.hosted.create.description": "Create a project in this OpenAnalyst cloud workspace.",
  "project.hosted.create.name": "Project name",
  "project.hosted.create.placeholder": "Client Work",
  "project.hosted.create.submit": "Create project",
  "project.hosted.create.uploadSubmit": "Upload project",
  "project.hosted.create.creating": "Creating...",
  "project.hosted.create.uploading": "Uploading...",
  "project.hosted.create.uploadFolder": "Choose folder",
  "project.hosted.create.selectedFolder": "{{name}} - {{count}} files",
  "project.hosted.create.selectedFolderFallback": "Selected folder",
  "project.hosted.create.error": "Project could not be created",
  "project.hosted.upload.toast.uploading.title": "Uploading cloud project",
  "project.hosted.upload.toast.success.title": "Project uploaded",
  "project.hosted.upload.toast.success.description": "{{name}} is ready with {{count}} files.",
  "project.hosted.upload.toast.failed.title": "Project upload failed",
  "miniChat.title": "Mini Chat",
  "miniChat.action": "Open Mini Chat",
  "miniChat.newDraft": "New Mini Chat draft",
  "miniChat.openMain": "Open main",
  "miniChat.noSession": "Start a mini chat draft from the composer below.",
  "miniChat.bootstrapPending": "Loading the selected session...",
  "session.header.refresh": "Refresh",
  "settings.hooks.title": "Hooks",
  "settings.hooks.description": "Run a command when OpenAnalyst reaches a lifecycle event. Stored in your settings.json.",
  "settings.hooks.empty": "No hooks configured for this event.",
  "settings.hooks.matcher": "Matcher",
  "settings.hooks.command": "Command",
  "settings.hooks.editor.title": "Raw configuration",
  "settings.hooks.editor.description": "Edit the hooks block as JSON. Keys are events, values are matcher groups.",
  "settings.hooks.save": "Save hooks",
  "settings.hooks.saved": "Hooks saved",
  "settings.hooks.invalidJson": "The hooks JSON could not be parsed.",
  "command.file.open": "Open file",
  "command.tab.close": "Close tab",
  "command.context.addSelection": "Add selection to context",
  "command.context.addSelection.description": "Add selected lines from the current file",
  "command.input.focus": "Focus input",
  "command.terminal.toggle": "Toggle terminal",
  "command.fileTree.toggle": "Toggle file tree",
  "command.review.toggle": "Toggle review",
  "command.terminal.new": "New terminal",
  "command.terminal.new.description": "Create a new terminal tab",
  "command.steps.toggle": "Toggle steps",
  "command.steps.toggle.description": "Show or hide steps for the current message",
  "command.message.previous": "Previous message",
  "command.message.previous.description": "Go to the previous user message",
  "command.message.next": "Next message",
  "command.message.next.description": "Go to the next user message",
  "command.model.choose": "Choose model",
  "command.model.choose.description": "Select a different model",
  "command.mcp.toggle": "Toggle MCPs",
  "command.mcp.toggle.description": "Toggle MCPs",
  "command.agent.cycle": "Cycle agent",
  "command.agent.cycle.description": "Switch to the next agent",
  "command.agent.cycle.reverse": "Cycle agent backwards",
  "command.agent.cycle.reverse.description": "Switch to the previous agent",
  "command.model.variant.cycle": "Cycle thinking effort",
  "command.model.variant.cycle.description": "Switch to the next effort level",
  "command.prompt.mode.shell": "Shell",
  "command.prompt.mode.normal": "Prompt",
  "command.permissions.autoaccept.enable": "Auto-accept permissions",
  "command.permissions.autoaccept.disable": "Stop auto-accepting permissions",
  "command.workspace.toggle": "Toggle workspaces",
  "command.workspace.toggle.description": "Enable or disable OpenAnalyst workspaces in the sidebar",
  "command.session.undo": "Undo",
  "command.session.undo.description": "Undo the last message",
  "command.session.redo": "Redo",
  "command.session.redo.description": "Redo the last undone message",
  "command.session.compact": "Compact session",
  "command.session.compact.description": "Summarize the session to reduce context size",
  "command.session.fork": "Fork from message",
  "command.session.fork.description": "Create a new session from a previous message",
  "command.session.share": "Share session",
  "command.session.share.description": "Share this session and copy the URL to clipboard",
  "command.session.unshare": "Unshare session",
  "command.session.unshare.description": "Stop sharing this session",
  "command.session.publishSnapshot10x": "Publish snapshot to 10x",
  "command.session.publishSnapshot10x.description":
    "Publish a redacted static snapshot through your connected 10x handle",
  "command.session.publishSnapshot10x.confirm.title": "Publish session snapshot to 10x?",
  "command.session.publishSnapshot10x.confirm.description":
    "This creates a public redacted static page for the current session through your connected 10x handle.",
  "command.session.publishSnapshot10x.confirm.sideEffect":
    "The page is not live-synced and does not use OpenAnalyst sharing.",

  "palette.search.placeholder": "Search files, commands, and sessions",
  "palette.empty": "No results found",
  "palette.group.commands": "Commands",
  "palette.group.files": "Files",

  "dialog.provider.search.placeholder": "Search providers",
  "dialog.provider.empty": "No providers found",
  "dialog.provider.group.popular": "Popular",
  "dialog.provider.group.other": "Other",
  "dialog.provider.tag.recommended": "Recommended",
  "dialog.provider.openanalyst.note": "Curated models including Claude, GPT, Gemini and more",
  "dialog.provider.openanalyst.tagline": "Reliable optimized models",
  "dialog.provider.openanalystGo.tagline": "Low cost subscription for everyone",
  "dialog.provider.anthropic.note": "Direct access to Claude models, including Pro and Max",
  "dialog.provider.copilot.note": "AI models for coding assistance via GitHub Copilot",
  "dialog.provider.openai.note": "GPT models for fast, capable general AI tasks",
  "dialog.provider.google.note": "Gemini models for fast, structured responses",
  "dialog.provider.openrouter.note": "Access all supported models from one provider",
  "dialog.provider.vercel.note": "Unified access to AI models with smart routing",

  "dialog.model.select.title": "Select model",
  "dialog.model.search.placeholder": "Search models",
  "dialog.model.empty": "No model results",
  "dialog.model.manage": "Manage models",
  "dialog.model.manage.description": "Customize which models appear in the model selector.",
  "dialog.model.manage.provider.toggle": "Toggle all {{provider}} models",

  "dialog.model.unpaid.freeModels.title": "Free models provided by OpenAnalyst",
  "dialog.model.unpaid.addMore.title": "Add more models from popular providers",

  "dialog.provider.viewAll": "Show more providers",

  "provider.connect.title": "Connect {{provider}}",
  "provider.connect.title.anthropicProMax": "Login with Claude Pro/Max",
  "provider.connect.selectMethod": "Select login method for {{provider}}.",
  "provider.connect.method.apiKey": "API key",
  "provider.connect.status.inProgress": "Authorization in progress...",
  "provider.connect.status.waiting": "Waiting for authorization...",
  "provider.connect.status.failed": "Authorization failed: {{error}}",
  "provider.connect.apiKey.description":
    "Enter your {{provider}} API key to connect your account and use {{provider}} models in OpenAnalyst.",
  "provider.connect.apiKey.label": "{{provider}} API key",
  "provider.connect.apiKey.placeholder": "API key",
  "provider.connect.apiKey.required": "API key is required",
  "provider.connect.openanalystZen.line1":
    "OpenAnalyst Zen gives you access to a curated set of reliable optimized models for coding agents.",
  "provider.connect.openanalystZen.line2":
    "With a single API key you'll get access to models such as Claude, GPT, Gemini, GLM and more.",
  "provider.connect.openanalystZen.visit.prefix": "Visit ",
  "provider.connect.openanalystZen.visit.link": "openanalyst.com/zen",
  "provider.connect.openanalystZen.visit.suffix": " to collect your API key.",
  "provider.connect.oauth.code.visit.prefix": "Visit ",
  "provider.connect.oauth.code.visit.link": "this link",
  "provider.connect.oauth.code.visit.suffix":
    " to collect your authorization code to connect your account and use {{provider}} models in OpenAnalyst.",
  "provider.connect.oauth.code.label": "{{method}} authorization code",
  "provider.connect.oauth.code.placeholder": "Authorization code",
  "provider.connect.oauth.code.required": "Authorization code is required",
  "provider.connect.oauth.code.invalid": "Invalid authorization code",
  "provider.connect.oauth.auto.visit.prefix": "Visit ",
  "provider.connect.oauth.auto.visit.link": "this link",
  "provider.connect.oauth.auto.visit.suffix":
    " and enter the code below to connect your account and use {{provider}} models in OpenAnalyst.",
  "provider.connect.oauth.auto.confirmationCode": "Confirmation code",
  "provider.connect.toast.connected.title": "{{provider}} connected",
  "provider.connect.toast.connected.description": "{{provider}} models are now available to use.",

  "provider.custom.title": "Custom provider",
  "provider.custom.description.prefix": "Configure an OpenAI-compatible provider. See the ",
  "provider.custom.description.link": "provider config docs",
  "provider.custom.description.suffix": ".",
  "provider.custom.field.providerID.label": "Provider ID",
  "provider.custom.field.providerID.placeholder": "myprovider",
  "provider.custom.field.providerID.description": "Lowercase letters, numbers, hyphens, or underscores",
  "provider.custom.field.name.label": "Display name",
  "provider.custom.field.name.placeholder": "My AI Provider",
  "provider.custom.field.baseURL.label": "Base URL",
  "provider.custom.field.baseURL.placeholder": "https://api.myprovider.com/v1",
  "provider.custom.field.apiKey.label": "API key",
  "provider.custom.field.apiKey.placeholder": "API key",
  "provider.custom.field.apiKey.description": "Optional. Leave empty if you manage auth via headers.",
  "provider.custom.models.label": "Models",
  "provider.custom.models.id.label": "ID",
  "provider.custom.models.id.placeholder": "model-id",
  "provider.custom.models.name.label": "Name",
  "provider.custom.models.name.placeholder": "Display Name",
  "provider.custom.models.remove": "Remove model",
  "provider.custom.models.add": "Add model",
  "provider.custom.headers.label": "Headers (optional)",
  "provider.custom.headers.key.label": "Header",
  "provider.custom.headers.key.placeholder": "Header-Name",
  "provider.custom.headers.value.label": "Value",
  "provider.custom.headers.value.placeholder": "value",
  "provider.custom.headers.remove": "Remove header",
  "provider.custom.headers.add": "Add header",
  "provider.custom.error.providerID.required": "Provider ID is required",
  "provider.custom.error.providerID.format": "Use lowercase letters, numbers, hyphens, or underscores",
  "provider.custom.error.providerID.exists": "That provider ID already exists",
  "provider.custom.error.name.required": "Display name is required",
  "provider.custom.error.baseURL.required": "Base URL is required",
  "provider.custom.error.baseURL.format": "Must start with http:// or https://",
  "provider.custom.error.required": "Required",
  "provider.custom.error.duplicate": "Duplicate",

  "provider.disconnect.toast.disconnected.title": "{{provider}} disconnected",
  "provider.disconnect.toast.disconnected.description": "{{provider}} models are no longer available.",

  "model.tag.free": "Free",
  "model.tag.credits": "Credits",
  "model.tag.latest": "Latest",
  "model.provider.anthropic": "Anthropic",
  "model.provider.openai": "OpenAI",
  "model.provider.google": "Google",
  "model.provider.xai": "xAI",
  "model.provider.meta": "Meta",
  "model.input.text": "text",
  "model.input.image": "image",
  "model.input.audio": "audio",
  "model.input.video": "video",
  "model.input.pdf": "pdf",
  "model.tooltip.allows": "Allows: {{inputs}}",
  "model.tooltip.reasoning.allowed": "Allows reasoning",
  "model.tooltip.reasoning.none": "No reasoning",
  "model.tooltip.context": "Context limit {{limit}}",

  "common.search.placeholder": "Search",
  "common.goBack": "Navigate back",
  "common.goForward": "Navigate forward",
  "common.loading": "Loading",
  "session.fileView.code": "Code",
  "session.fileView.preview": "Preview",
  "session.fileView.edit": "Edit",
  "session.artifactReview.askChanges": "Ask for follow-up changes",
  "session.artifactReview.busy": "Wait for the current response to finish.",
  "session.artifactReview.busyButton": "Session busy",
  "session.artifactReview.context": "Reviewing artifact",
  "session.artifactReview.disabled": "Current session cannot accept follow-ups.",
  "session.artifactReview.hide": "Hide",
  "session.artifactReview.launcher": "Review artifact",
  "session.artifactReview.placeholder": "Ask for follow-up changes to this artifact...",
  "session.artifactReview.selectedTextAttached": "Selected text attached",
  "session.artifactReview.send": "Send",
  "session.artifactReview.sending": "Sending",
  "session.fileView.unsavedChanges.title": "Unsaved changes",
  "session.fileView.unsavedChanges.description":
    "You have unsaved changes that will be lost if you leave without saving.",
  "session.fileView.unsavedChanges.discard": "Discard",
  "common.loading.ellipsis": "...",
  "common.cancel": "Cancel",
  "common.open": "Open",
  "common.connect": "Connect",
  "common.connected": "Connected",
  "common.disconnect": "Disconnect",
  "common.disconnected": "Disconnected",
  "common.continue": "Continue",
  "common.submit": "Submit",
  "common.save": "Save",
  "common.saving": "Saving...",
  "common.default": "Default",
  "common.notConfigured": "Not configured",
  "common.attachment": "attachment",

  "prompt.placeholder.shell": "Enter shell command... {{example}}",
  "prompt.placeholder.normal": 'Ask anything... "{{example}}"',
  "prompt.placeholder.simple": "Ask anything...",
  "prompt.placeholder.summarizeComments": "Summarize comments…",
  "prompt.placeholder.summarizeComment": "Summarize comment…",
  "prompt.mode.shell": "Shell",
  "prompt.mode.normal": "Prompt",
  "prompt.mode.shell.exit": "esc to exit",
  "session.child.promptDisabled": "Subagent sessions cannot be prompted.",
  "session.child.backToParent": "Back to main session.",

  "prompt.example.1": "Create an analysis report",
  "prompt.example.2": "Summarize the key insights",
  "prompt.example.3": "Find trends in this data",
  "prompt.example.4": "Compare options and recommend next steps",
  "prompt.example.5": "Prepare a client-ready summary",
  "prompt.example.6": "Turn these notes into action items",
  "prompt.example.7": "Review this document for gaps",
  "prompt.example.8": "Explain this in simple language",
  "prompt.example.9": "Draft a project status update",
  "prompt.example.10": "Build a weekly progress report",
  "prompt.example.11": "Find risks and opportunities",
  "prompt.example.12": "Create a plan for this goal",
  "prompt.example.13": "Analyze customer feedback",
  "prompt.example.14": "Summarize sales performance",
  "prompt.example.15": "Create a marketing brief",
  "prompt.example.16": "Organize this information clearly",
  "prompt.example.17": "Extract important numbers",
  "prompt.example.18": "Make this easier to understand",
  "prompt.example.19": "Prepare talking points",
  "prompt.example.20": "Find what needs attention",
  "prompt.example.21": "Write a follow-up email",
  "prompt.example.22": "Create an executive summary",
  "prompt.example.23": "Compare this month and last month",
  "prompt.example.24": "Suggest practical improvements",
  "prompt.example.25": "Make a decision checklist",

  "prompt.popover.emptyResults": "No matching results",
  "prompt.popover.emptyCommands": "No matching commands",
  "prompt.popover.hint.navigate": "navigate",
  "prompt.popover.hint.select": "select",
  "prompt.popover.hint.dismiss": "dismiss",
  "prompt.dropzone.label": "Drop images, PDFs, spreadsheets, or text files here",
  "prompt.dropzone.file.label": "Drop to @mention file",
  "prompt.slash.badge.custom": "custom",
  "prompt.slash.badge.skill": "skill",
  "prompt.slash.badge.mcp": "mcp",
  "prompt.context.active": "active",
  "prompt.context.includeActiveFile": "Include active file",
  "prompt.context.removeActiveFile": "Remove active file from context",
  "prompt.context.removeFile": "Remove file from context",
  "prompt.action.attachFile": "Add files",
  "prompt.attachment.remove": "Remove attachment",
  "prompt.attachment.preview": "Preview {name}",
  "prompt.action.send": "Send",
  "prompt.action.stop": "Stop",
  "prompt.action.transcribe": "Record voice",
  "prompt.action.transcribe.stop": "Stop recording",
  "prompt.action.transcribe.transcribing": "Transcribing...",

  "prompt.toast.pasteUnsupported.title": "Unsupported attachment",
  "prompt.toast.pasteUnsupported.description": "Only images, PDFs, spreadsheets, or text files can be attached here.",
  "prompt.toast.transcriptionFailed.title": "Transcription failed",
  "prompt.toast.transcriptionFailed.description": "Unable to transcribe the recording.",
  "prompt.toast.modelAgentRequired.title": "Select an agent",
  "prompt.toast.modelAgentRequired.description": "Choose an agent before running a shell command.",
  "prompt.toast.worktreeCreateFailed.title": "Failed to create worktree",
  "prompt.toast.sessionCreateFailed.title": "Failed to create session",
  "prompt.toast.shellSendFailed.title": "Failed to send shell command",
  "prompt.toast.commandSendFailed.title": "Failed to send command",
  "prompt.toast.promptSendFailed.title": "Failed to send prompt",
  "prompt.toast.promptSendFailed.description": "Unable to retrieve session",
  "prompt.unsupportedAttachment.title": "Unable to send message",
  "prompt.unsupportedAttachment.description.image": "Remove images or switch models to send this message",
  "prompt.unsupportedAttachment.description.default":
    "Remove unsupported attachments or switch models to send this message",
  "prompt.unsupportedAttachment.ok": "OK",

  "dialog.mcp.title": "MCPs",
  "dialog.mcp.description": "{{enabled}} of {{total}} enabled",
  "dialog.mcp.empty": "No MCPs configured",

  "dialog.lsp.empty": "LSPs auto-detected from file types",
  "dialog.plugins.empty": "Plugins configured in openanalyst.json",

  "mcp.status.connected": "connected",
  "mcp.status.failed": "failed",
  "mcp.status.needs_auth": "needs auth",
  "mcp.status.disabled": "disabled",

  "dialog.fork.empty": "No messages to fork from",

  "dialog.directory.search.placeholder": "Search folders",
  "dialog.directory.empty": "No folders found",

  "app.server.unreachable": "Could not reach {{server}}",
  "app.server.retrying": "Retrying automatically...",
  "app.server.otherServers": "Other servers",

  "dialog.server.title": "Servers",
  "dialog.server.description": "Switch which OpenAnalyst server this app connects to.",
  "dialog.server.search.placeholder": "Search servers",
  "dialog.server.empty": "No servers yet",
  "dialog.server.add.title": "Add server",
  "dialog.server.add.url": "Server address",
  "dialog.server.add.placeholder": "http://localhost:4096",
  "dialog.server.add.error": "Could not connect to server",
  "dialog.server.add.checking": "Checking...",
  "dialog.server.add.button": "Add server",
  "dialog.server.add.name": "Server name (optional)",
  "dialog.server.add.namePlaceholder": "Localhost",
  "dialog.server.add.username": "Username (optional)",
  "dialog.server.add.usernamePlaceholder": "username",
  "dialog.server.add.password": "Password (optional)",
  "dialog.server.add.passwordPlaceholder": "password",
  "dialog.server.edit.title": "Edit server",
  "dialog.server.default.title": "Default server",
  "dialog.server.default.description":
    "Connect to this server on app launch instead of starting a local server. Requires restart.",
  "dialog.server.default.none": "No server selected",
  "dialog.server.default.set": "Set current server as default",
  "dialog.server.default.clear": "Clear",
  "dialog.server.action.remove": "Remove server",

  "dialog.server.menu.edit": "Edit",
  "dialog.server.menu.default": "Set as default",
  "dialog.server.menu.defaultRemove": "Remove default",
  "dialog.server.menu.delete": "Delete",
  "dialog.server.current": "Current Server",
  "dialog.server.status.default": "Default",
  "server.row.noUsername": "no username",

  "wsl.server.add": "Add WSL server",
  "wsl.server.addShort": "Add WSL",
  "wsl.server.label": "WSL",
  "wsl.server.menu.label": "WSL server",
  "wsl.server.retryStart": "Retry start",
  "wsl.server.updating": "Updating...",
  "wsl.onboarding.step.distro": "Choose distro",
  "wsl.onboarding.step.openanalyst": "OpenAnalyst",
  "wsl.onboarding.checkingRuntime": "Checking WSL...",
  "wsl.onboarding.restartRequired": "Windows needs a restart to finish installing WSL.",
  "wsl.onboarding.ready": "WSL is ready.",
  "wsl.onboarding.required": "WSL is required to continue.",
  "wsl.onboarding.checkingDistros": "Checking distros...",
  "wsl.onboarding.installingDistro": "Installing {{distro}}...",
  "wsl.onboarding.checkingDistro": "Checking {{distro}}...",
  "wsl.onboarding.listingDistros": "Listing distros...",
  "wsl.onboarding.distroReady": "{{distro}} is ready.",
  "wsl.onboarding.distroNotInstalled": "{{distro}} is not installed yet.",
  "wsl.onboarding.openDistroOnce": "Open {{distro}} once to finish setup.",
  "wsl.onboarding.finishingDistro": "Finishing setup for {{distro}}.",
  "wsl.onboarding.pickDistro": "Pick a distro or install one below.",
  "wsl.onboarding.checkingOpencode": "Checking OpenAnalyst...",
  "wsl.onboarding.checkingOpencodeIn": "Checking OpenAnalyst in {{distro}}...",
  "wsl.onboarding.updatingOpencode": "Updating OpenAnalyst...",
  "wsl.onboarding.updatingOpencodeIn": "Updating OpenAnalyst in {{distro}}...",
  "wsl.onboarding.updateOpencodeIn": "Update OpenAnalyst in {{distro}}.",
  "wsl.onboarding.updateOpencode": "Update OpenAnalyst",
  "wsl.onboarding.openanalystReadyIn": "OpenAnalyst is ready in {{distro}}.",
  "wsl.onboarding.openanalystReady": "OpenAnalyst is ready.",
  "wsl.onboarding.installOpencodeIn": "Install OpenAnalyst in {{distro}}.",
  "wsl.onboarding.installOpencode": "Install OpenAnalyst",
  "wsl.onboarding.chooseDistroFirst": "Choose a distro first.",
  "wsl.onboarding.loadFailed": "Failed to load WSL state.",
  "wsl.onboarding.loading": "Loading...",
  "wsl.onboarding.installWsl": "Install WSL",
  "wsl.onboarding.windowsRestartRequired": "Restart Windows to finish installing WSL, then reopen OpenAnalyst.",
  "wsl.onboarding.next": "Next",
  "wsl.onboarding.refresh": "Refresh",
  "wsl.onboarding.allDistrosAdded": "All installed distros are already added.",
  "wsl.onboarding.noDistros": "No distros detected yet.",
  "wsl.onboarding.install": "Install",
  "wsl.onboarding.installing": "Installing...",
  "wsl.onboarding.installDistro": "Install distro",
  "wsl.onboarding.wsl2Required": "WSL 2 is required.",
  "wsl.onboarding.toolsRequired": "This distro needs bash and curl.",
  "wsl.onboarding.openTerminal": "Open terminal",
  "wsl.onboarding.path": "Path: {{path}}",
  "wsl.onboarding.notFound": "not found",
  "wsl.onboarding.version": "Version: {{version}}",
  "wsl.onboarding.unknown": "unknown",
  "wsl.onboarding.desktopVersion": "desktop {{version}}",
  "wsl.onboarding.versionMismatch": "Installed version does not match the desktop app version.",
  "wsl.onboarding.adding": "Adding...",

  "dialog.project.edit.title": "Edit project",
  "dialog.project.edit.name": "Name",
  "dialog.project.edit.icon": "Icon",
  "dialog.project.edit.icon.alt": "Project icon",
  "dialog.project.edit.icon.hint": "Click or drag an image",
  "dialog.project.edit.icon.recommended": "Recommended: 128x128px",
  "dialog.project.edit.color": "Color",
  "dialog.project.edit.color.select": "Select {{color}} color",
  "dialog.project.edit.worktree.startup": "Workspace startup script",
  "dialog.project.edit.worktree.startup.description": "Runs after creating a new workspace (worktree).",
  "dialog.project.edit.worktree.startup.placeholder": "e.g. bun install",

  "dialog.releaseNotes.action.getStarted": "Get started",
  "dialog.releaseNotes.action.next": "Next",
  "dialog.releaseNotes.action.hideFuture": "Don't show these in the future",
  "dialog.releaseNotes.media.alt": "Release preview",

  "context.breakdown.title": "Context Breakdown",
  "context.breakdown.note": 'Approximate breakdown of input tokens. "Other" includes tool definitions and overhead.',
  "context.breakdown.system": "System",
  "context.breakdown.user": "User",
  "context.breakdown.assistant": "Assistant",
  "context.breakdown.tool": "Tool Calls",
  "context.breakdown.other": "Other",

  "context.systemPrompt.title": "System Prompt",
  "context.rawMessages.title": "Raw messages",

  "context.stats.session": "Session",
  "context.stats.messages": "Messages",
  "context.stats.provider": "Provider",
  "context.stats.model": "Model",
  "context.stats.limit": "Context Limit",
  "context.stats.totalTokens": "Total Tokens",
  "context.stats.usage": "Usage",
  "context.stats.inputTokens": "Input Tokens",
  "context.stats.outputTokens": "Output Tokens",
  "context.stats.reasoningTokens": "Reasoning Tokens",
  "context.stats.cacheTokens": "Cache Tokens (read/write)",
  "context.stats.userMessages": "User Messages",
  "context.stats.assistantMessages": "Assistant Messages",
  "context.stats.totalCost": "Total Cost",
  "context.stats.sessionCreated": "Session Created",
  "context.stats.lastActivity": "Last Activity",

  "context.usage.tokens": "Tokens",
  "context.usage.usage": "Usage",
  "context.usage.cost": "Cost",
  "context.usage.clickToView": "Click to view context",
  "context.usage.view": "View context usage",

  "language.en": "English",
  "language.zh": "简体中文",
  "language.zht": "繁體中文",
  "language.ko": "한국어",
  "language.de": "Deutsch",
  "language.es": "Español",
  "language.fr": "Français",
  "language.da": "Dansk",
  "language.ja": "日本語",
  "language.pl": "Polski",
  "language.ru": "Русский",
  "language.ar": "العربية",
  "language.no": "Norsk",
  "language.br": "Português (Brasil)",
  "language.bs": "Bosanski",
  "language.th": "ไทย",
  "language.tr": "Türkçe",

  "toast.language.title": "Language",
  "toast.language.description": "Switched to {{language}}",

  "toast.theme.title": "Theme switched",
  "toast.scheme.title": "Color scheme",

  "toast.workspace.enabled.title": "Workspaces enabled",
  "toast.workspace.enabled.description": "OpenAnalyst workspaces are now shown in the sidebar",
  "toast.workspace.disabled.title": "Workspaces disabled",
  "toast.workspace.disabled.description": "Only the main OpenAnalyst workspace is shown in the sidebar",

  "toast.permissions.autoaccept.on.title": "Auto-accepting permissions",
  "toast.permissions.autoaccept.on.description": "Permission requests will be automatically approved",
  "toast.permissions.autoaccept.off.title": "Stopped auto-accepting permissions",
  "toast.permissions.autoaccept.off.description": "Permission requests will require approval",

  "toast.model.none.title": "No model selected",
  "toast.model.none.description": "Connect a provider to summarize this session",

  "toast.file.loadFailed.title": "Failed to load file",
  "toast.file.listFailed.title": "Failed to list files",

  "toast.context.noLineSelection.title": "No line selection",
  "toast.context.noLineSelection.description": "Select a line range in a file tab first.",

  "toast.session.share.copyFailed.title": "Failed to copy URL to clipboard",
  "toast.session.share.success.title": "Session shared",
  "toast.session.share.success.description": "Share URL copied to clipboard!",
  "toast.session.share.failed.title": "Failed to share session",
  "toast.session.share.failed.description": "An error occurred while sharing the session",

  "toast.session.unshare.success.title": "Session unshared",
  "toast.session.unshare.success.description": "Session unshared successfully!",
  "toast.session.unshare.failed.title": "Failed to unshare session",
  "toast.session.unshare.failed.description": "An error occurred while unsharing the session",
  "toast.session.publishSnapshot10x.success.title": "Snapshot published",
  "toast.session.publishSnapshot10x.success.description": "10x snapshot URL copied to clipboard.",
  "toast.session.publishSnapshot10x.copyFailed.description": "Snapshot opened, but the URL could not be copied.",
  "toast.session.publishSnapshot10x.failed.title": "Failed to publish snapshot",
  "toast.session.publishSnapshot10x.failed.description": "Check that 10X Handle is connected for this project.",

  "toast.session.listFailed.title": "Failed to load sessions for {{project}}",
  "toast.project.reloadFailed.title": "Failed to reload {{project}}",

  "toast.update.title": "Update available",
  "toast.update.description": "A new version of OpenAnalyst ({{version}}) is now available to install.",
  "toast.update.action.installRestart": "Install and restart",
  "toast.update.action.notYet": "Not yet",

  "error.page.title": "Something went wrong",
  "error.page.description": "An error occurred while loading the application.",
  "error.page.details.label": "Error Details",
  "error.page.action.restart": "Restart",
  "error.page.action.report": "Report Error",
  "error.page.action.reported": "Error Reported",
  "error.page.action.checking": "Checking...",
  "error.page.action.checkUpdates": "Check for updates",
  "error.page.action.updateTo": "Update to {{version}}",
  "error.page.report.email.label": "Email",
  "error.page.report.email.placeholder": "you@example.com",
  "error.page.report.message.label": "Message",
  "error.page.report.message.placeholder": "What were you doing when this happened?",
  "error.page.report.submit": "Send report",
  "error.page.report.cancel": "Cancel",
  "error.page.report.sending": "Sending...",
  "error.page.report.sent": "Report sent: {{reportId}}",
  "error.page.report.failed": "Could not send report: {{message}}",
  "error.page.report.diagnosticsNote": "Recent diagnostics will be attached.",
  "error.page.circular": "[Circular]",
  "error.page.version": "Version: {{version}}",
  "error.page.diagnostics.openViewer": "Open log viewer",
  "error.page.diagnostics.openFolder": "Open logs folder",
  "error.page.diagnostics.copyRecent": "Copy recent diagnostics",
  "error.page.diagnostics.viewerOpened": "Opened diagnostics viewer.",
  "error.page.diagnostics.folderOpened": "Opened diagnostics folder.",
  "error.page.diagnostics.copied": "Copied recent diagnostics.",

  "error.dev.rootNotFound":
    "Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got misspelled?",

  "error.globalSync.connectFailed": "Could not connect to server. Is there a server running at `{{url}}`?",
  "error.globalSDK.noServerAvailable": "No server available",
  "error.globalSDK.serverNotAvailable": "Server not available",
  "error.childStore.persistedCacheCreateFailed": "Failed to create persisted cache",
  "error.childStore.persistedProjectMetadataCreateFailed": "Failed to create persisted project metadata",
  "error.childStore.persistedProjectIconCreateFailed": "Failed to create persisted project icon",
  "error.childStore.storeCreateFailed": "Failed to create store",
  "directory.error.invalidUrl": "Invalid directory in URL.",

  "error.chain.unknown": "Unknown error",
  "error.server.invalidConfiguration": "Invalid configuration",
  "error.chain.causedBy": "Caused by:",
  "error.chain.apiError": "API error",
  "error.chain.status": "Status: {{status}}",
  "error.chain.retryable": "Retryable: {{retryable}}",
  "error.chain.responseBody": "Response body:\n{{body}}",
  "error.chain.didYouMean": "Did you mean: {{suggestions}}",
  "error.chain.modelNotFound": "Model not found: {{provider}}/{{model}}",
  "error.chain.checkConfig": "Check your config (openanalyst.json) provider/model names",
  "error.chain.mcpFailed": 'MCP server "{{name}}" failed. Note, OpenAnalyst does not support MCP authentication yet.',
  "error.chain.providerAuthFailed": "Provider authentication failed ({{provider}}): {{message}}",
  "error.chain.providerInitFailed":
    'Failed to initialize provider "{{provider}}". Check credentials and configuration.',
  "error.chain.configJsonInvalid": "Config file at {{path}} is not valid JSON(C)",
  "error.chain.configJsonInvalidWithMessage": "Config file at {{path}} is not valid JSON(C): {{message}}",
  "error.chain.configDirectoryTypo":
    'Directory "{{dir}}" in {{path}} is not valid. Rename the directory to "{{suggestion}}" or remove it. This is a common typo.',
  "error.chain.configFrontmatterError": "Failed to parse frontmatter in {{path}}:\n{{message}}",
  "error.chain.configInvalid": "Config file at {{path}} is invalid",
  "error.chain.configInvalidWithMessage": "Config file at {{path}} is invalid: {{message}}",

  "notification.permission.title": "Permission required",
  "notification.permission.description": "{{sessionTitle}} in {{projectName}} needs permission",
  "notification.question.title": "Question",
  "notification.question.description": "{{sessionTitle}} in {{projectName}} has a question",
  "notification.action.goToSession": "Go to session",

  "notification.session.responseReady.title": "Response ready",
  "notification.session.error.title": "Session error",
  "notification.session.error.fallbackDescription": "An error occurred",
  "notification.session.creditsExhausted.title": "Not enough credits",
  "notification.session.creditsExhausted.description":
    "This task needs more credits than are currently available. Open Billing to add credits and retry.",

  "composer.rateLimit.title": "Not enough credits for this task",
  "composer.rateLimit.description":
    "This task needs more credits than are currently available. Open Billing to add credits and retry.",
  "composer.rateLimit.description.withReset":
    "Your rate limit resets on {resetAt}. Open Billing to add credits and continue now.",
  "composer.rateLimit.cta": "Open Billing",

  "home.recentProjects": "Recent projects",
  "home.empty.title": "No recent projects",
  "home.empty.description": "Get started by opening a local project",

  "session.tab.session": "Session",
  "session.tab.review": "Review",
  "session.tab.context": "Context",
  "session.tab.preview": "Preview",
  "session.tab.subagent": "Subagent",
  "session.panel.reviewAndFiles": "Review and files",
  "session.subagent.untitled": "Subagent session",
  "session.subagent.empty": "No messages loaded for this subagent session.",
  "session.subagent.open": "Open",
  "session.subagent.inspect": "Inspect subagent",
  "session.fusion.action": "Fuse results",
  "session.fusion.running": "Fusing",
  "session.fusion.dialog.title": "Fuse results",
  "session.fusion.dialog.description":
    "Choose at least two source sessions. OpenAnalyst will create a new synthesis session in this workspace.",
  "session.fusion.dialog.skipped": "{{count}} source sessions without assistant output were skipped.",
  "session.fusion.dialog.truncated": "{{count}} source outputs were shortened for the draft.",
  "session.fusion.dialog.promptTruncated": "The generated draft was shortened to stay within the prompt budget.",
  "session.fusion.dialog.draftLabel": "Fusion draft",
  "session.fusion.dialog.run": "Create synthesis",
  "session.fusion.defaultObjective": "Synthesize the selected subagent results",
  "session.fusion.sessionTitle": "Fusion synthesis",
  "session.fusion.noTargets.title": "No child sessions",
  "session.fusion.noTargets.description": "Fusion needs at least two child sessions with assistant output.",
  "session.review.filesChanged": "{{count}} Files Changed",
  "session.review.change.one": "Change",
  "session.review.change.other": "Changes",
  "session.review.loadingChanges": "Loading changes...",
  "session.review.empty": "No changes in this session yet",
  "session.review.noVcs": "No Git Version Control System detected, changes not displayed",
  "session.review.noVcs.createGit.title": "Create a Git repository",
  "session.review.noVcs.createGit.description": "Track, review, and undo changes in this project",
  "session.review.noVcs.createGit.actionLoading": "Creating Git repository...",
  "session.review.noVcs.createGit.action": "Create Git repository",
  "session.review.structure.loading": "Loading workspace structure...",
  "session.review.structure.unmarked.title": "Use this as an OpenAnalyst workspace",
  "session.review.structure.unmarked.description":
    "Create the standard context, inputs, workstreams, decisions, and output folders for this project.",
  "session.review.structure.mark": "Mark as OpenAnalyst workspace",
  "session.review.structure.marking": "Marking workspace...",
  "session.review.structure.git": "Enable Git tracking",
  "session.review.structure.gitPending": "Enabling Git...",
  "session.review.structure.invalid.title": "OpenAnalyst structure needs attention",
  "session.review.structure.invalid.description":
    "The workspace marker could not be read. OpenAnalyst will not rewrite it automatically.",
  "session.review.structure.emptyNote": "No README note yet",
  "session.review.structure.fileCount.one": "{{count}} file",
  "session.review.structure.fileCount.other": "{{count}} files",
  "session.review.structure.layers": "Engine layers",
  "session.review.structure.layersNote":
    "These folders feed OpenAnalyst's engine. Indexed folders are searchable through the knowledge graph; Synced folders mirror to your connected workspace.",
  "session.review.structure.folders": "Workspace folders",
  "session.review.structure.badge.indexed": "Indexed",
  "session.review.structure.badge.indexedHint": "Indexed into the OpenAnalyst knowledge graph for recall.",
  "session.review.structure.badge.synced": "Synced",
  "session.review.structure.badge.syncedHint": "Mirrored to your connected OpenAnalyst workspace.",
  "session.review.structure.layer.context": "Context",
  "session.review.structure.layer.knowledge": "Knowledge",
  "session.review.structure.layer.okf": "OKF",
  "session.review.noSnapshot": "Snapshot tracking is disabled in config, so session changes are unavailable",
  "session.review.noChanges": "No changes",
  "session.review.noUncommittedChanges": "No uncommitted changes yet",
  "session.review.noBranchChanges": "No branch changes yet",

  "session.files.selectToOpen": "Select a file to open",
  "session.files.all": "All files",
  "session.files.output": "Output",
  "session.files.noOutput": "No output files yet",
  "session.files.empty": "No files",
  "session.files.binaryContent": "Binary file (content cannot be displayed)",

  "session.messages.renderEarlier": "Render earlier messages",
  "session.messages.loadingEarlier": "Loading earlier messages...",
  "session.messages.loadEarlier": "Load earlier messages",
  "session.messages.loading": "Loading messages...",
  "session.messages.jumpToLatest": "Jump to latest",

  "session.context.addToContext": "Add {{selection}} to context",
  "session.todo.title": "Todos",
  "session.todo.collapse": "Collapse",
  "session.todo.expand": "Expand",
  "session.todo.progress": "{{done}} of {{total}} todos completed",
  "session.question.progress": "{{current}} of {{total}} questions",
  "session.followupDock.summary.one": "{{count}} queued message",
  "session.followupDock.summary.other": "{{count}} queued messages",
  "session.followupDock.sendNow": "Send now",
  "session.followupDock.edit": "Edit",
  "session.followupDock.delete": "Delete",
  "session.followupDock.dragHandle": "Drag to reorder queued message",
  "session.followupDock.itemMenu": "Queued message actions",
  "session.followupDock.collapse": "Collapse queued messages",
  "session.followupDock.expand": "Expand queued messages",
  "session.workingDock.label": "Working for {{duration}}",
  "session.revertDock.summary.one": "{{count}} rolled back message",
  "session.revertDock.summary.other": "{{count}} rolled back messages",
  "session.revertDock.collapse": "Collapse rolled back messages",
  "session.revertDock.expand": "Expand rolled back messages",
  "session.revertDock.restore": "Restore message",

  "session.new.title": "Build anything",
  "session.new.worktree.main": "Main workspace",
  "session.new.worktree.mainWithBranch": "Main workspace",
  "session.new.worktree.create": "Create new workspace",
  "session.new.lastModified": "Last modified",

  "session.new.greeting.morning": "Good morning",
  "session.new.greeting.afternoon": "Good afternoon",
  "session.new.greeting.evening": "Good evening",
  "session.new.greeting.midnight": "Midnight Owl",
  "session.new.greeting.fallback": "Hello",

  "session.new.plug.brands": "Analyze your data from {{brands}} and get analysis reports in minutes.",
  "session.new.plug.default": "Pull insights, build reports, and answer questions about your project in minutes.",

  "session.new.today.label": "Today",
  "session.new.today.empty": "No calendar tasks for today.",
  "session.new.today.connectCalendar": "Connect a calendar plugin to see today's tasks here.",
  "session.new.today.template": "Help me prepare for: {{task}}. Pull anything from this project that's relevant.",

  "session.new.recent.label": "Recent activity",
  "session.new.recent.empty": "No recent sessions in this project yet.",
  "session.new.recent.template":
    'Continue from where we left off on "{{title}}". Summarize the latest state and suggest the next step.',

  "session.new.starter.label": "Suggested starts",
  "session.new.starter.explore.title": "Explore this project",
  "session.new.starter.explore.description": "Summarize the important files and call out the best first task.",
  "session.new.starter.explore.prompt":
    "Explore this project. Summarize the important files, explain how it is organized, and suggest the best first task to work on.",
  "session.new.starter.nextTask.title": "Find the next task",
  "session.new.starter.nextTask.description": "Review project context and propose a focused next step.",
  "session.new.starter.nextTask.prompt":
    "Review this project and propose the highest-impact next task. Check recent context, likely TODOs, and tests before recommending what to do.",
  "session.new.starter.checks.title": "Check project health",
  "session.new.starter.checks.description": "Look for setup, test, or runtime problems to fix first.",
  "session.new.starter.checks.prompt":
    "Check this project for setup, test, typecheck, or runtime issues. Tell me what is failing or risky and what to fix first.",

  "session.header.search.placeholder": "Search {{project}}",
  "session.header.searchFiles": "Search files",
  "session.header.switcher.label": "Switch session",
  "session.header.switcher.active": "active",
  "session.header.switcher.busy": "busy",
  "session.header.switcher.idle": "idle",
  "session.header.openIn": "Open in",
  "session.header.open.action": "Open {{app}}",
  "session.header.open.ariaLabel": "Open in {{app}}",
  "session.header.open.menu": "Open options",
  "session.header.open.copyPath": "Copy path",
  "session.header.open.finder": "Finder",
  "session.header.open.fileExplorer": "File Explorer",
  "session.header.open.fileManager": "File Manager",
  "session.header.open.app.vscode": "VS Code",
  "session.header.open.app.cursor": "Cursor",
  "session.header.open.app.zed": "Zed",
  "session.header.open.app.textmate": "TextMate",
  "session.header.open.app.antigravity": "Antigravity",
  "session.header.open.app.terminal": "Terminal",
  "session.header.open.app.iterm2": "iTerm2",
  "session.header.open.app.ghostty": "Ghostty",
  "session.header.open.app.warp": "Warp",
  "session.header.open.app.xcode": "Xcode",
  "session.header.open.app.androidStudio": "Android Studio",
  "session.header.open.app.powershell": "PowerShell",
  "session.header.open.app.sublimeText": "Sublime Text",

  "status.popover.trigger": "Status",
  "status.popover.ariaLabel": "Server configurations",
  "status.popover.tab.servers": "Servers",
  "status.popover.tab.mcp": "MCP",
  "status.popover.tab.lsp": "LSP",
  "status.popover.tab.plugins": "Plugins",
  "status.popover.action.manageServers": "Manage servers",

  "session.share.popover.title": "Publish on web",
  "session.share.popover.description.shared":
    "This session is public on the web. It is accessible to anyone with the link.",
  "session.share.popover.description.unshared":
    "Share session publicly on the web. It will be accessible to anyone with the link.",
  "session.share.action.share": "Share",
  "session.share.action.publish": "Publish",
  "session.share.action.publishing": "Publishing...",
  "session.share.action.unpublish": "Unpublish",
  "session.share.action.unpublishing": "Unpublishing...",
  "session.share.action.view": "View",
  "session.share.copy.copied": "Copied",
  "session.share.copy.copyLink": "Copy link",
  "session.header.menu.pinChat": "Pin chat",
  "session.header.menu.unpinChat": "Unpin chat",
  "session.header.menu.openSideChat": "Open side chat",
  "session.header.menu.copy": "Copy",
  "session.header.menu.copyChatLink": "Copy chat link",
  "session.header.menu.copyShareLink": "Copy public link",
  "session.header.menu.fork": "Fork",
  "session.header.menu.forkChat": "Fork chat",
  "session.header.menu.addAutomation": "Add automation...",
  "session.header.menu.openInNewWindow": "Open in new window",
  "session.header.menu.deleteChat": "Delete chat",

  "lsp.tooltip.none": "No LSP servers",
  "lsp.label.connected": "{{count}} LSP",
  "settings.lsp.title": "Language servers",
  "settings.lsp.description": "Language servers are auto-detected from the active project files.",

  "prompt.loading": "Loading prompt...",
  "terminal.loading": "Loading terminal...",
  "terminal.title": "Terminal",
  "terminal.title.numbered": "Terminal {{number}}",
  "session.preview.title": "Live Preview",
  "session.preview.open": "Open Preview",
  "session.preview.empty": "No preview URL detected",
  "session.preview.waiting": "Start a local dev server in the terminal to open a live preview.",
  "session.preview.invalid": "Preview URL is invalid",
  "session.preview.blocked": "Only local previews can be embedded",
  "session.preview.timeout": "Preview has not finished loading",
  "session.preview.retry": "Retry",
  "session.preview.reload": "Reload preview",
  "session.preview.openExternal": "Open preview externally",
  "terminal.close": "Close terminal",
  "terminal.connectionLost.title": "Connection Lost",
  "terminal.connectionLost.abnormalClose": "WebSocket closed abnormally: {{code}}",
  "terminal.connectionLost.description":
    "The terminal connection was interrupted. This can happen when the server restarts.",

  "common.closeTab": "Close tab",
  "common.dismiss": "Dismiss",
  "common.moreCountSuffix": " (+{{count}} more)",
  "common.requestFailed": "Request failed",
  "common.moreOptions": "More options",
  "common.learnMore": "Learn more",
  "common.rename": "Rename",
  "common.reset": "Reset",
  "common.archive": "Archive",
  "common.delete": "Delete",
  "common.close": "Close",
  "common.edit": "Edit",
  "common.loadMore": "Load more",
  "common.key.esc": "ESC",
  "common.key.ctrl": "Ctrl",
  "common.key.alt": "Alt",
  "common.key.shift": "Shift",
  "common.key.meta": "Meta",
  "common.key.space": "Space",
  "common.key.backspace": "Backspace",
  "common.key.enter": "Enter",
  "common.key.tab": "Tab",
  "common.key.delete": "Delete",
  "common.key.home": "Home",
  "common.key.end": "End",
  "common.key.pageUp": "Page Up",
  "common.key.pageDown": "Page Down",
  "common.key.insert": "Insert",
  "common.unknown": "unknown",

  "common.time.justNow": "Just now",
  "common.time.minutesAgo.short": "{{count}}m ago",
  "common.time.hoursAgo.short": "{{count}}h ago",
  "common.time.daysAgo.short": "{{count}}d ago",

  "sidebar.menu.toggle": "Toggle menu",
  "sidebar.nav.projectsAndSessions": "Projects and sessions",
  "sidebar.settings": "Settings",
  "sidebar.help": "Help",
  "sidebar.profile": "Profile",
  "sidebar.workspaces.enable": "Enable OpenAnalyst workspaces",
  "sidebar.workspaces.disable": "Disable OpenAnalyst workspaces",
  "sidebar.workspaces.badgeTooltip": "OpenAnalyst workspaces enabled",
  "sidebar.smartwork.reviewAccess": "Review Smartwork access",
  "sidebar.smartwork.badgeTooltip": "Smartwork Cloud access enabled",
  "sidebar.gettingStarted.title": "Getting started",
  "sidebar.gettingStarted.line1": "OpenAnalyst includes free models so you can start immediately.",
  "sidebar.gettingStarted.line2": "Connect OpenAnalyst integrations to use tools and managed models.",
  "sidebar.project.recentSessions": "Recent sessions",
  "sidebar.project.viewAllSessions": "View all sessions",
  "sidebar.project.openDirectory": "Open in Finder",
  "sidebar.project.copyDirectory": "Copy folder path",
  "sidebar.project.clearNotifications": "Clear notifications",
  "sidebar.project.archivedChats": "Archived chats",
  "sidebar.project.promoteViewLabel": "Save view label to shared config",
  "sidebar.project.promoteSuccess": "Shared project label saved",
  "sidebar.project.promoteSuccessDescription": "This project label is now available from shared config.",
  "archivedChats.title": "Archived chats",
  "archivedChats.empty.title": "No archived chats in this project",
  "archivedChats.empty.description": "Archived chats from this project will appear here.",
  "archivedChats.loading": "Loading archived chats...",
  "archivedChats.error.title": "Failed to load archived chats",
  "archivedChats.error.retry": "Retry",
  "archivedChats.open": "Open",
  "archivedChats.unarchive": "Unarchive",
  "archivedChats.unarchiveFailed.title": "Failed to unarchive chat",
  "archivedChats.archivedAt": "Archived {{time}}",
  "archivedChats.updatedAt": "Updated {{time}} ago",
  "sidebar.threads.title": "Threads",
  "sidebar.threads.pinned": "Pinned",
  "sidebar.threads.settings": "Thread view settings",
  "sidebar.threads.enabled": "Project management view",
  "sidebar.threads.layer.merged": "Merged",
  "sidebar.threads.layer.shared": "Shared config",
  "sidebar.threads.layer.local": "Local only",
  "sidebar.threads.filter.all": "All",
  "sidebar.threads.filter.active": "Active",
  "sidebar.threads.filter.waiting": "Waiting",
  "sidebar.threads.empty.all": "No threads loaded",
  "sidebar.threads.empty.active": "No active threads",
  "sidebar.threads.empty.waiting": "No threads waiting",
  "sidebar.thread.pin": "Pin thread",
  "sidebar.thread.unpin": "Unpin thread",
  "sidebar.thread.openChat": "Open chat",
  "sidebar.thread.renameChat": "Rename chat",
  "sidebar.thread.archiveChat": "Archive chat",
  "sidebar.thread.viewLabel": "Set view label",
  "sidebar.thread.clearViewLabel": "Clear view label",
  "sidebar.thread.openDirectory": "Open in Finder",
  "sidebar.thread.copyDirectory": "Copy working directory",
  "sidebar.thread.copySessionID": "Copy session ID",
  "sidebar.thread.copyDeeplink": "Copy deeplink",
  "sidebar.thread.menu.open": "Open",
  "sidebar.thread.menu.organize": "Organize",
  "sidebar.thread.menu.chat": "Chat",
  "sidebar.thread.menu.context": "Context",
  "sidebar.thread.viewLabelDialog.title": "Set view label",
  "sidebar.thread.viewLabelDialog.description":
    "This changes only the project-management sidebar label. The canonical chat title stays unchanged.",
  "sidebar.thread.renameChatDialog.title": "Rename chat",
  "sidebar.thread.renameChatDialog.description": "This changes the canonical chat title.",
  "sidebar.thread.viewLabelInput": "View label",
  "sidebar.thread.renameChatInput": "Chat title",
  "sidebar.thread.canonicalTitle": "Canonical title",
  "sidebar.thread.project": "Project",
  "sidebar.thread.workspace": "Workspace",
  "sidebar.thread.stage": "Stage",
  "sidebar.thread.pinState": "Pin state",
  "sidebar.thread.pinned": "Pinned",
  "sidebar.thread.notPinned": "Not pinned",
  "sidebar.thread.promoteViewLabel": "Save view label to shared config",
  "sidebar.thread.promoteSuccess": "Shared thread label saved",
  "sidebar.thread.promoteSuccessDescription": "This thread label is now available from shared config.",
  "dialog.archivedChats.title": "Archived chats",
  "dialog.archivedChats.empty": "No archived chats in this project",
  "dialog.archivedChats.loading": "Loading archived chats...",
  "dialog.archivedChats.error": "Archived chats could not be loaded",
  "dialog.archivedChats.retry": "Retry",
  "dialog.archivedChats.unarchive": "Unarchive",
  "dialog.archivedChats.unarchiving": "Unarchiving...",
  "dialog.archivedChats.archivedJustNow": "Archived just now",
  "dialog.archivedChats.archivedAgo": "Archived {{time}} ago",
  "sidebar.empty.title": "No projects open",
  "sidebar.empty.description": "Open a project to get started",

  "debugBar.ariaLabel": "Development performance diagnostics",
  "debugBar.na": "n/a",
  "debugBar.nav.label": "NAV",
  "debugBar.nav.tip":
    "Last completed route transition touching a session page, measured from router start until the first paint after it settles.",
  "debugBar.fps.label": "FPS",
  "debugBar.fps.tip": "Rolling frames per second over the last 5 seconds.",
  "debugBar.frame.label": "FRAME",
  "debugBar.frame.tip": "Worst frame time over the last 5 seconds.",
  "debugBar.jank.label": "JANK",
  "debugBar.jank.tip": "Frames over 32ms in the last 5 seconds.",
  "debugBar.long.label": "LONG",
  "debugBar.long.tip": "Blocked time and long-task count in the last 5 seconds. Max task: {{max}}.",
  "debugBar.delay.label": "DELAY",
  "debugBar.delay.tip": "Worst observed input delay in the last 5 seconds.",
  "debugBar.inp.label": "INP",
  "debugBar.inp.tip":
    "Approximate interaction duration over the last 5 seconds. This is INP-like, not the official Web Vitals INP.",
  "debugBar.cls.label": "CLS",
  "debugBar.cls.tip": "Cumulative layout shift for the current app lifetime.",
  "debugBar.mem.label": "MEM",
  "debugBar.mem.tipUnavailable": "Used JS heap vs heap limit. Chromium only.",
  "debugBar.mem.tip": "Used JS heap vs heap limit. {{used}} of {{limit}}.",

  "app.name.desktop": "OpenAnalyst Desktop",
  "profile.title": "Profile",
  "profile.description": "Your account information",
  "profile.section.account": "Account",
  "profile.field.email": "Email",
  "profile.field.email.description": "Your account email address",
  "profile.field.name": "Name",
  "profile.field.name.description": "Your display name",
  "profile.notLoggedIn": "Not logged in",
  "profile.section.session": "Session",
  "profile.action.signOut": "Sign out",
  "profile.action.logout": "Logout",

  "settings.section.desktop": "Desktop",
  "settings.section.workspace": "Workspace",
  "settings.section.server": "Server",
  "settings.tab.general": "General",
  "settings.tab.shortcuts": "Shortcuts",
  "settings.brand.title": "Brand Guidelines",
  "settings.brand.description": "Manage project Markdown that guides OpenAnalyst brand behavior and Generative Studio output.",
  "settings.brand.emptyWorkspace": "Open a project to manage workspace brand guidelines.",
  "settings.brand.toast.saved": "Brand guidelines updated",
  "settings.diagnostics.title": "Diagnostics",
  "settings.diagnostics.description": "Open local logs outside the app webview and copy recent structured diagnostics.",
  "settings.diagnostics.status.enabled": "Diagnostics are enabled",
  "settings.diagnostics.status.unavailable": "Diagnostics are unavailable",
  "settings.diagnostics.status.loading": "Loading diagnostics status...",
  "settings.diagnostics.status.retention": "Retaining {{days}} days, up to {{mb}} MB.",
  "settings.diagnostics.status.copied": "Copied {{count}} diagnostic entries.",
  "settings.diagnostics.action.openViewer": "Open log viewer",
  "settings.diagnostics.action.openFolder": "Open logs folder",
  "settings.diagnostics.action.copyRecent": "Copy recent diagnostics",
  "settings.diagnostics.action.refresh": "Refresh",
  "settings.diagnostics.field.logDir": "Diagnostics folder",
  "settings.diagnostics.field.currentFile": "Current JSONL file",
  "settings.diagnostics.field.viewerUrl": "Viewer URL",
  "settings.desktop.section.wsl": "WSL",
  "settings.desktop.wsl.title": "WSL integration",
  "settings.desktop.wsl.description": "Run the OpenAnalyst server inside WSL on Windows.",

  "settings.general.section.appearance": "Appearance",
  "settings.general.section.advanced": "Advanced",
  "settings.general.section.notifications": "System notifications",
  "settings.general.section.updates": "Updates",
  "settings.general.section.sounds": "Sound effects",
  "settings.general.section.feed": "Feed",
  "settings.general.section.display": "Display",
  "settings.general.section.projectManagement": "Project Management",
  "settings.general.projectManagement.crmCloud.title": "Cloud CRM",
  "settings.general.projectManagement.crmCloud.description":
    "Create or reuse this project's shared CRM workspace, import local CRM data, keep a read-only backup, and make cloud PostgreSQL authoritative.",
  "settings.general.projectManagement.crmCloud.connection":
    "Uses your signed-in OpenAnalyst organization and this project's registered cloud identity. CRM roles remain explicit.",
  "settings.general.projectManagement.crmCloud.enable": "Enable cloud CRM",
  "settings.general.projectManagement.crmCloud.enabling": "Enabling...",
  "settings.general.projectManagement.crmCloud.error": "Cloud CRM could not be enabled.",
  "settings.general.projectManagement.crmCloud.toast.completed.title": "Cloud CRM enabled",
  "settings.general.projectManagement.crmCloud.toast.completed.description": "Imported {{records}} CRM records. Cloud PostgreSQL is now authoritative for this project.",
  "settings.general.section.controlRoom": "Control Room",
  "settings.general.controlRoom.previewPanel.title": "Live Preview",
  "settings.general.controlRoom.previewPanel.description":
    "Show detected local dev-server previews in the session side panel",
  "settings.general.controlRoom.sessionSwitcher.title": "Session switcher",
  "settings.general.controlRoom.sessionSwitcher.description": "Show root and child sessions in the desktop title bar",
  "settings.general.controlRoom.readOnlySubagentPanel.title": "Subagent panel",
  "settings.general.controlRoom.readOnlySubagentPanel.description":
    "Inspect child sessions without switching away from the parent",
  "settings.general.controlRoom.multiRunFusion.title": "Multi-run fusion",
  "settings.general.controlRoom.multiRunFusion.description":
    "Create a new synthesis session from child outputs under the same parent",
  "settings.general.controlRoom.miniChat.title": "Mini Chat",
  "settings.general.controlRoom.miniChat.description": "Open a compact desktop chat window for the current session",
  "settings.general.controlRoom.settingsPolish.title": "Skills polish",
  "settings.general.controlRoom.settingsPolish.description": "Show source and status labels for skills and plugins",

  "settings.general.row.language.title": "Language",
  "settings.general.row.language.description": "Change the display language for OpenAnalyst",
  "settings.general.row.shell.title": "Terminal Shell",
  "settings.general.row.shell.description":
    "Choose the shell used for your terminal. Compatible shells are also used for agent tool calls.",
  "settings.general.row.shell.autoDefault": "Auto (Default)",
  "settings.general.row.shell.terminalOnly": "terminal only",
  "settings.general.row.appearance.title": "Appearance",
  "settings.general.row.appearance.description": "Customise how OpenAnalyst looks on your device",
  "settings.general.row.colorScheme.title": "Color scheme",
  "settings.general.row.colorScheme.description": "Choose whether OpenAnalyst follows the system, light, or dark theme",
  "settings.general.row.theme.title": "Theme",
  "settings.general.row.theme.description": "Customise how OpenAnalyst is themed.",
  "settings.general.row.font.title": "Code Font",
  "settings.general.row.font.description": "Customise the font used in code blocks",
  "settings.general.row.terminalFont.title": "Terminal Font",
  "settings.general.row.terminalFont.description": "Customise the font used in the terminal",
  "settings.general.row.uiFont.title": "UI Font",
  "settings.general.row.uiFont.description": "Customise the font used throughout the interface",
  "settings.general.row.followup.title": "Follow-up behavior",
  "settings.general.row.followup.description": "Choose whether follow-up prompts steer immediately or wait in a queue",
  "settings.general.row.followup.option.queue": "Queue",
  "settings.general.row.followup.option.steer": "Steer",
  "settings.general.row.showFileTree.title": "File tree",
  "settings.general.row.showFileTree.description": "Show the file tree toggle and panel in desktop sessions",
  "settings.general.row.showNavigation.title": "Navigation controls",
  "settings.general.row.showNavigation.description": "Show the back and forward buttons in the desktop title bar",
  "settings.general.row.showSearch.title": "Command palette",
  "settings.general.row.showSearch.description": "Show the search and command palette button in the desktop title bar",
  "settings.general.row.showTerminal.title": "Terminal",
  "settings.general.row.showTerminal.description": "Show the terminal button in the desktop title bar",
  "settings.general.row.showStatus.title": "Server status",
  "settings.general.row.showStatus.description": "Show the server status button in the desktop title bar",
  "settings.general.row.reasoningSummaries.title": "Show reasoning summaries",
  "settings.general.row.reasoningSummaries.description": "Display model reasoning summaries in the timeline",
  "settings.general.row.shellToolPartsExpanded.title": "Expand shell tool parts",
  "settings.general.row.shellToolPartsExpanded.description":
    "Show shell tool parts expanded by default in the timeline",
  "settings.general.row.editToolPartsExpanded.title": "Expand edit tool parts",
  "settings.general.row.editToolPartsExpanded.description":
    "Show edit, write, and patch tool parts expanded by default in the timeline",
  "settings.general.projectManagement.row.status.title": "Shared config",
  "settings.general.projectManagement.row.status.description":
    "Shows whether shared project-management naming is configured.",
  "settings.general.projectManagement.row.starterRoot.title": "Starter project location",
  "settings.general.projectManagement.row.starterRoot.description":
    "Folder where OpenAnalyst suggested projects are created.",
  "settings.general.projectManagement.status.enabled": "Enabled",
  "settings.general.projectManagement.status.disabled": "Disabled",
  "settings.general.projectManagement.status.unconfigured": "Not configured",
  "settings.general.projectManagement.row.layer.title": "Layer mode",
  "settings.general.projectManagement.row.layer.description":
    "Controls how shared and local sidebar naming are combined.",
  "settings.general.projectManagement.layer.merged": "Merged",
  "settings.general.projectManagement.layer.shared": "Shared config",
  "settings.general.projectManagement.layer.local": "Local only",
  "settings.general.projectManagement.row.projectTemplate.title": "Project template",
  "settings.general.projectManagement.row.projectTemplate.description":
    "Template used for project labels in the sidebar.",
  "settings.general.projectManagement.row.threadTemplate.title": "Thread template",
  "settings.general.projectManagement.row.threadTemplate.description":
    "Template used for thread labels in the sidebar.",
  "settings.general.projectManagement.row.sharedCounts.title": "Shared labels",
  "settings.general.projectManagement.row.sharedCounts.description":
    "Configured shared project labels, thread labels, and pinned items.",
  "settings.general.projectManagement.empty": "Not configured",
  "settings.general.projectManagement.counts":
    "Project labels: {{projects}} · Thread labels: {{threads}} · Pinned items: {{pinned}}",
  "settings.general.row.showSessionProgressBar.title": "Show session progress bar",
  "settings.general.row.showSessionProgressBar.description":
    "Display the animated progress bar at the top of the session when the agent is working",

  "settings.general.row.wayland.title": "Use native Wayland",
  "settings.general.row.wayland.description": "Disable X11 fallback on Wayland. Requires restart.",
  "settings.general.row.wayland.tooltip":
    "On Linux with mixed refresh-rate monitors, native Wayland can be more stable.",

  "settings.general.row.releaseNotes.title": "Release notes",
  "settings.general.row.releaseNotes.description": "Show What's New popups after updates",

  "settings.updates.row.startup.title": "Check for updates on startup",
  "settings.updates.row.startup.description": "Automatically check for updates when OpenAnalyst launches",
  "settings.updates.row.check.title": "Check for updates",
  "settings.updates.row.check.description": "Manually check for updates and install if available",
  "settings.updates.action.checkNow": "Check now",
  "settings.updates.action.checking": "Checking...",
  "settings.updates.toast.latest.title": "You're up to date",
  "settings.updates.toast.latest.description": "You're running the latest version of OpenAnalyst.",
  "sound.option.none": "None",
  "sound.option.alert01": "Alert 01",
  "sound.option.alert02": "Alert 02",
  "sound.option.alert03": "Alert 03",
  "sound.option.alert04": "Alert 04",
  "sound.option.alert05": "Alert 05",
  "sound.option.alert06": "Alert 06",
  "sound.option.alert07": "Alert 07",
  "sound.option.alert08": "Alert 08",
  "sound.option.alert09": "Alert 09",
  "sound.option.alert10": "Alert 10",
  "sound.option.bipbop01": "Bip-bop 01",
  "sound.option.bipbop02": "Bip-bop 02",
  "sound.option.bipbop03": "Bip-bop 03",
  "sound.option.bipbop04": "Bip-bop 04",
  "sound.option.bipbop05": "Bip-bop 05",
  "sound.option.bipbop06": "Bip-bop 06",
  "sound.option.bipbop07": "Bip-bop 07",
  "sound.option.bipbop08": "Bip-bop 08",
  "sound.option.bipbop09": "Bip-bop 09",
  "sound.option.bipbop10": "Bip-bop 10",
  "sound.option.staplebops01": "Staplebops 01",
  "sound.option.staplebops02": "Staplebops 02",
  "sound.option.staplebops03": "Staplebops 03",
  "sound.option.staplebops04": "Staplebops 04",
  "sound.option.staplebops05": "Staplebops 05",
  "sound.option.staplebops06": "Staplebops 06",
  "sound.option.staplebops07": "Staplebops 07",
  "sound.option.nope01": "Nope 01",
  "sound.option.nope02": "Nope 02",
  "sound.option.nope03": "Nope 03",
  "sound.option.nope04": "Nope 04",
  "sound.option.nope05": "Nope 05",
  "sound.option.nope06": "Nope 06",
  "sound.option.nope07": "Nope 07",
  "sound.option.nope08": "Nope 08",
  "sound.option.nope09": "Nope 09",
  "sound.option.nope10": "Nope 10",
  "sound.option.nope11": "Nope 11",
  "sound.option.nope12": "Nope 12",
  "sound.option.yup01": "Yup 01",
  "sound.option.yup02": "Yup 02",
  "sound.option.yup03": "Yup 03",
  "sound.option.yup04": "Yup 04",
  "sound.option.yup05": "Yup 05",
  "sound.option.yup06": "Yup 06",

  "settings.general.notifications.agent.title": "Agent",
  "settings.general.notifications.agent.description":
    "Show system notification when the agent is complete or needs attention",
  "settings.general.notifications.permissions.title": "Permissions",
  "settings.general.notifications.permissions.description": "Show system notification when a permission is required",
  "settings.general.notifications.errors.title": "Errors",
  "settings.general.notifications.errors.description": "Show system notification when an error occurs",

  "settings.general.sounds.agent.title": "Agent",
  "settings.general.sounds.agent.description": "Play sound when the agent is complete or needs attention",
  "settings.general.sounds.permissions.title": "Permissions",
  "settings.general.sounds.permissions.description": "Play sound when a permission is required",
  "settings.general.sounds.errors.title": "Errors",
  "settings.general.sounds.errors.description": "Play sound when an error occurs",

  "settings.shortcuts.title": "Keyboard shortcuts",
  "settings.shortcuts.reset.button": "Reset to defaults",
  "settings.shortcuts.reset.toast.title": "Shortcuts reset",
  "settings.shortcuts.reset.toast.description": "Keyboard shortcuts have been reset to defaults.",
  "settings.shortcuts.conflict.title": "Shortcut already in use",
  "settings.shortcuts.conflict.description": "{{keybind}} is already assigned to {{titles}}.",
  "settings.shortcuts.unassigned": "Unassigned",
  "settings.shortcuts.pressKeys": "Press keys",
  "settings.shortcuts.search.placeholder": "Search shortcuts",
  "settings.shortcuts.search.empty": "No shortcuts found",

  "settings.shortcuts.group.general": "General",
  "settings.shortcuts.group.session": "Session",
  "settings.shortcuts.group.navigation": "Navigation",
  "settings.shortcuts.group.modelAndAgent": "Model and agent",
  "settings.shortcuts.group.terminal": "Terminal",
  "settings.shortcuts.group.prompt": "Prompt",

  "settings.providers.title": "Providers",
  "settings.providers.description": "Provider settings will be configurable here.",
  "settings.providers.section.connected": "Connected providers",
  "settings.providers.connected.empty": "No connected providers",
  "settings.providers.connected.environmentDescription": "Connected from your environment variables",
  "settings.providers.section.popular": "Popular providers",
  "settings.providers.custom.description": "Add an OpenAI-compatible provider by base URL.",
  "settings.providers.tag.environment": "Environment",
  "settings.providers.tag.config": "Config",
  "settings.providers.tag.custom": "Custom",
  "settings.providers.tag.other": "Other",
  "settings.providers.models.inComposer": "In composer",
  "settings.providers.models.toggle": "Show {{provider}} models in the composer",
  "settings.providers.models.count": "{{selected}} of {{available}} models",
  "settings.providers.models.dialog.title": "{{provider}} models",
  "settings.providers.models.dialog.description": "Choose exactly which {{provider}} models appear in the composer.",
  "settings.providers.models.dialog.notice": "New {{provider}} models stay hidden until you select them.",
  "settings.providers.models.search": "Search {{count}} models…",
  "settings.providers.models.search.empty": "No models match this search.",
  "settings.providers.models.selected": "Selected · {{count}}",
  "settings.providers.models.selected.empty": "No models selected. Choose All models to add one.",
  "settings.providers.models.all": "All models · {{count}}",
  "settings.providers.models.clear": "Clear selection",
  "settings.providers.models.done": "Done · {{count}} selected",
  "settings.providers.models.fallback.title": "Model changed",
  "settings.providers.models.fallback.description": "{{model}} is now selected because the previous model is hidden.",
  "settings.integrations.title": "Integrations",
  "settings.integrations.description": "Connect your OpenAnalyst integrations for use through the built-in MCP bridge.",
  "settings.integrations.search.placeholder": "Search integrations",
  "settings.integrations.search.empty": "No integrations found",
  "settings.integrations.filter.all": "All",
  "settings.integrations.filter.connected": "Connected",
  "settings.integrations.section.connected": "Connected integrations",
  "settings.integrations.section.available": "Available integrations",
  "settings.integrations.connected.empty": "No integrations available yet",
  "settings.integrations.action.refresh": "Refresh",
  "settings.integrations.action.add": "Add",
  "settings.integrations.action.disconnect": "Disconnect",
  "settings.integrations.status.active": "active",
  "settings.integrations.status.pending": "pending",
  "settings.integrations.status.expired": "expired",
  "settings.integrations.status.error": "error",
  "settings.integrations.status.notConnected": "not connected",
  "settings.integrations.toast.disconnected.title": "{{name}} disconnected",
  "settings.integrations.toast.disconnected.description": "{{name}} has been disconnected.",
  "settings.integrations.toast.error.title": "Unable to update integrations",
  "settings.integrations.toast.error.loginRequired": "Please log in to add integrations.",
  "settings.integrations.disconnect.title": "Disconnect integration",
  "settings.integrations.disconnect.confirm": "Disconnect {{name}}?",
  "settings.integrations.disconnect.description":
    "The agent will no longer be able to use this integration until you reconnect it.",
  "settings.integrations.disconnect.button": "Disconnect",
  "settings.productSuite.title": "Product Suite",
  "settings.productSuite.description": "Connect your Product Suite account and choose which handle this project should use.",
  "settings.productSuite.section.account": "Account",
  "settings.productSuite.section.status": "Credentials",
  "settings.productSuite.section.handles": "Handles",
  "settings.productSuite.section.pat": "Personal access token",
  "settings.productSuite.action.refresh": "Refresh handles",
  "settings.productSuite.action.refreshing": "Refreshing...",
  "settings.productSuite.action.sendOtp": "Send OTP",
  "settings.productSuite.action.sendingOtp": "Sending...",
  "settings.productSuite.action.verifyOtp": "Verify OTP",
  "settings.productSuite.action.verifyingOtp": "Verifying...",
  "settings.productSuite.action.savingJwt": "Saving...",
  "settings.productSuite.status.configured.title": "Credential status",
  "settings.productSuite.status.configured.description": "Central Product Suite credential store for this device.",
  "settings.productSuite.status.login.title": "Product Suite account",
  "settings.productSuite.status.login.connected": "Signed in through the Product Suite App.",
  "settings.productSuite.status.login.missing": "Sign in through the Product Suite App to load handles.",
  "settings.productSuite.status.baseURL.title": "Product Suite App",
  "settings.productSuite.status.baseURL.description": "Open the Product Suite App.",
  "settings.productSuite.status.connectedHandles.title": "Connected handles",
  "settings.productSuite.status.connectedHandles.description": "Handles with a token or PAT available.",
  "settings.productSuite.status.connectedHandles.count": "{{count}} connected",
  "settings.productSuite.activeHandle.title": "Active handle",
  "settings.productSuite.activeHandle.description": "Default handle for this project and its Product Suite apps.",
  "settings.productSuite.handles.empty": "No handles found. Sign in through the Product Suite App to load your roster.",
  "settings.productSuite.handles.emptyShort": "No handles",
  "settings.productSuite.handles.tag.active": "Active",
  "settings.productSuite.handles.tag.connected": "Connected",
  "settings.productSuite.handles.tag.pat": "PAT saved",
  "settings.productSuite.handles.tag.noPat": "No PAT",
  "settings.productSuite.pat.title": "Handle PAT",
  "settings.productSuite.pat.description": "Optional PAT for {{handle}}.",
  "settings.productSuite.pat.noHandle": "Select a handle before adding a PAT.",
  "settings.productSuite.pat.placeholder": "Paste PAT",
  "settings.productSuite.pat.save": "Save PAT",
  "settings.productSuite.pat.clear": "Clear PAT",
  "settings.productSuite.pat.clearing": "Clearing...",
  "settings.productSuite.otp.title": "Reauthenticate",
  "settings.productSuite.otp.description": "Refresh handles from your Product Suite account email.",
  "settings.productSuite.otp.email.placeholder": "Email",
  "settings.productSuite.otp.code.placeholder": "OTP code",
  "settings.productSuite.otp.sent": "Code sent to {{destination}}.",
  "settings.productSuite.jwt.title": "Manual access token",
  "settings.productSuite.jwt.description": "Optional 10x access_token for live handle discovery. id_token cannot refresh handles.",
  "settings.productSuite.jwt.placeholder": "Paste 10x access_token",
  "settings.productSuite.jwt.save": "Use access token",
  "settings.productSuite.handlePat.placeholder": "Paste PAT for this handle",
  "settings.productSuite.handlePat.save": "Save PAT",
  "settings.productSuite.handlePat.clear": "Clear PAT",
  "settings.productSuite.toast.updated.title": "Product Suite updated",
  "settings.productSuite.toast.updated.description": "Shared credentials are up to date.",
  "settings.productSuite.toast.refreshed.description": "Handles refreshed from Product Suite.",
  "settings.productSuite.toast.reauthenticated.description": "Access token and handles refreshed from Product Suite.",
  "settings.productSuite.toast.jwtUpdated.description": "Manual access token saved and handles refreshed.",
  "settings.productSuite.toast.otpSent.description": "OTP sent. Enter the code to continue.",
  "settings.productSuite.toast.otpSent.destination": "OTP sent to {{destination}}.",
  "settings.productSuite.toast.cleared.title": "PAT cleared",
  "settings.productSuite.toast.cleared.description": "The selected handle no longer has a saved PAT.",
  "settings.productSuite.toast.error.title": "Unable to update Product Suite",
  "settings.productSuite.error.noJwt": "No JWT was returned. Reauthenticate or paste a JWT manually.",
  "settings.productSuite.error.refreshUnavailable": "Desktop JWT refresh is unavailable in this environment.",
  "settings.productSuite.error.emailRequired": "Enter the Product Suite account email.",
  "settings.productSuite.error.otpUnavailable": "OTP sign-in is unavailable in this environment.",
  "settings.productSuite.error.noOtpSession": "Product Suite did not return an OTP session.",
  "settings.productSuite.error.otpRequired": "Enter the email and OTP code.",
  "settings.productSuite.error.jwtRequired": "Paste a JWT before saving.",
  "settings.productSuite.error.idTokenRefreshUnavailable":
    "This is an id_token. Reauthenticate with that email or paste the matching 10x access_token.",
  "settings.productSuite.error.idTokenRefreshMismatch":
    "That id_token does not match the current desktop session. Reauthenticate with that email or paste its matching 10x access_token.",
  "settings.plugins.title": "Plugins",
  "settings.plugins.description": "Install and manage OpenAnalyst UI plugins for the active workspace.",
  "settings.plugins.empty.directory": "Open a project before managing workspace plugins.",
  "settings.plugins.reload.title": "Reload required",
  "settings.plugins.reload.description":
    "Plugin config changed. Reload the workspace to activate installed apps and tools.",
  "settings.plugins.reload.action": "Reload workspace",
  "settings.plugins.install.title": "Install plugin",
  "settings.plugins.install.description":
    "Add an npm package, git spec, file URL, or local path to the project plugin config.",
  "settings.plugins.install.placeholder": "@scope/plugin, git URL, file URL, or ./local-plugin.ts",
  "settings.plugins.install.action": "Install",
  "settings.plugins.action.refresh": "Refresh",
  "settings.plugins.section.configured": "Configured plugins",
  "settings.plugins.section.builtin": "Built-in plugins",
  "settings.plugins.section.discovered": "Discovered local plugins",
  "settings.plugins.empty.configured": "No project plugins configured yet.",
  "settings.plugins.catalog.title": "Suggested plugins",
  "settings.plugins.catalog.description": "Start from built-in app examples or installable plugin package patterns.",
  "settings.plugins.catalog.recommended": "Recommended",
  "settings.plugins.catalog.hosted": "Hosted",
  "settings.plugins.catalog.deprecated": "Deprecated",
  "settings.plugins.catalog.blocked": "Blocked",
  "settings.plugins.catalog.revoked": "Revoked",
  "settings.plugins.catalog.unavailable": "Unavailable",
  "settings.plugins.catalog.publisher": "Publisher: {{name}}",
  "settings.plugins.catalog.install": "Install",
  "settings.plugins.catalog.builtIn": "Built in",
  "settings.plugins.toast.installed.title": "Plugin configured",
  "settings.plugins.toast.installed.description": "{{spec}} was added to plugin config.",
  "settings.plugins.toast.removed.title": "Plugin removed",
  "settings.plugins.toast.removed.description": "{{spec}} was removed from plugin config.",
  "settings.plugins.toast.reloaded.title": "Workspace reloaded",
  "settings.plugins.toast.error.title": "Unable to update plugins",
  "settings.plugins.error.install": "Plugin install failed",
  "settings.plugins.error.remove": "Plugin removal failed",
  "settings.plugins.error.reload": "Workspace reload failed",
  "credits.balance.title": "Credit Balance",
  "credits.balance.available": "{{count}} credits available",
  "credits.balance.loading": "Loading balance...",
  "credits.balance.error": "Could not load balance",
  "credits.balance.plan": "Plan",
  "credits.balance.purchased": "Purchased",
  "settings.tab.billing": "Billing",
  "settings.billing.description": "Manage your credits and purchases",
  "settings.billing.section.balance": "Credit Balance",
  "settings.billing.balance.total": "Total Available",
  "settings.billing.balance.plan": "Plan Credits",
  "settings.billing.balance.planDescription": "Included with your {{plan}} plan",
  "settings.billing.balance.purchased": "Purchased Credits",
  "settings.billing.balance.purchasedDescription": "From {{count}} active purchase(s)",
  "settings.billing.balance.remaining": "{{remaining}} of {{limit}}",
  "settings.billing.expiring": "{{credits}} credits expiring soon",
  "settings.billing.section.packs": "Buy Credits",
  "settings.billing.rate": "Conversion Rate",
  "settings.billing.rateValue": "${{dollars}} = {{credits}} credits",
  "settings.billing.amount.label": "Amount (USD)",
  "settings.billing.amount.placeholder": "Enter amount",
  "settings.billing.amount.preview": "{{amount}} = {{credits}} credits",
  "settings.billing.amount.range": "Amount must be between ${{min}} and ${{max}}",
  "settings.billing.amount.step": "Amount must be a multiple of ${{step}}",
  "settings.billing.packs.buy": "Buy",
  "settings.billing.packs.buying": "Redirecting...",
  "settings.billing.section.history": "Purchase History",
  "settings.billing.history.empty": "No purchases yet",
  "settings.billing.history.credits": "+{{credits}} credits",
  "settings.billing.toast.checkoutFailed": "Could not start checkout. Please try again.",
  "settings.models.title": "Models",
  "settings.models.description": "Model settings will be configurable here.",
  "settings.agents.title": "Agents",
  "settings.agents.description": "Agent settings will be configurable here.",
  "settings.commands.title": "Commands",
  "settings.commands.description": "Command settings will be configurable here.",
  "settings.mcp.title": "MCP",
  "settings.mcp.description": "MCP settings will be configurable here.",

  "settings.permissions.title": "Permissions",
  "settings.permissions.description": "Control what tools the server can use by default.",
  "settings.permissions.section.tools": "Tools",
  "settings.permissions.toast.updateFailed.title": "Failed to update permissions",

  "settings.permissions.action.allow": "Allow",
  "settings.permissions.action.ask": "Ask",
  "settings.permissions.action.deny": "Deny",

  "settings.permissions.tool.read.title": "Read",
  "settings.permissions.tool.read.description": "Reading a file (matches the file path)",
  "settings.permissions.tool.edit.title": "Edit",
  "settings.permissions.tool.edit.description": "Modify files, including edits, writes, patches, and multi-edits",
  "settings.permissions.tool.glob.title": "Glob",
  "settings.permissions.tool.glob.description": "Match files using glob patterns",
  "settings.permissions.tool.grep.title": "Grep",
  "settings.permissions.tool.grep.description": "Search file contents using regular expressions",
  "settings.permissions.tool.list.title": "List",
  "settings.permissions.tool.list.description": "List files within a directory",
  "settings.permissions.tool.bash.title": "Bash",
  "settings.permissions.tool.bash.description": "Run shell commands",
  "settings.permissions.tool.task.title": "Task",
  "settings.permissions.tool.task.description": "Launch sub-agents",
  "settings.permissions.tool.skill.title": "Skill",
  "settings.permissions.tool.skill.description": "Load a skill by name",
  "settings.permissions.tool.lsp.title": "LSP",
  "settings.permissions.tool.lsp.description": "Run language server queries",
  "settings.permissions.tool.todowrite.title": "Todo Write",
  "settings.permissions.tool.todowrite.description": "Update the todo list",
  "settings.permissions.tool.webfetch.title": "Web Fetch",
  "settings.permissions.tool.webfetch.description": "Fetch content from a URL",
  "settings.permissions.tool.websearch.title": "Web Search",
  "settings.permissions.tool.websearch.description": "Search the web",
  "settings.permissions.tool.account_billing.title": "Account Billing",
  "settings.permissions.tool.account_billing.description": "Read your OpenAnalyst credit balance and plan usage",
  "settings.permissions.tool.external_directory.title": "External Directory",
  "settings.permissions.tool.external_directory.description": "Access files outside the project directory",
  "settings.permissions.tool.doom_loop.title": "Doom Loop",
  "settings.permissions.tool.doom_loop.description": "Detect repeated tool calls with identical input",

  "session.delete.failed.title": "Failed to delete session",
  "session.delete.title": "Delete session",
  "session.delete.confirm": 'Delete session "{{name}}"?',
  "session.delete.button": "Delete session",

  "workspace.new": "New workspace",
  "workspace.type.local": "main workspace",
  "workspace.type.sandbox": "workspace",
  "workspace.localReadOnly": "The main workspace is your project folder — it can't be reset or deleted here. Reset and Delete apply to sandbox workspaces.",
  "workspace.create.failed.title": "Failed to create workspace",
  "workspace.delete.failed.title": "Failed to delete workspace",
  "workspace.resetting.title": "Resetting workspace",
  "workspace.resetting.description": "This may take a minute.",
  "workspace.reset.failed.title": "Failed to reset workspace",
  "workspace.reset.success.title": "Workspace reset",
  "workspace.reset.success.description": "Workspace now matches the project baseline.",
  "workspace.error.stillPreparing": "Workspace is still preparing",
  "workspace.status.checking": "Checking for unmerged changes...",
  "workspace.status.error": "Unable to verify git status.",
  "workspace.status.clean": "No unmerged changes detected.",
  "workspace.status.dirty": "Unmerged changes detected in this workspace.",
  "workspace.delete.title": "Delete workspace",
  "workspace.delete.confirm": 'Delete workspace "{{name}}"?',
  "workspace.delete.button": "Delete workspace",
  "workspace.reset.title": "Reset workspace",
  "workspace.reset.confirm": 'Reset workspace "{{name}}"?',
  "workspace.reset.button": "Reset workspace",
  "workspace.reset.archived.none": "No active sessions will be archived.",
  "workspace.reset.archived.one": "1 session will be archived.",
  "workspace.reset.archived.many": "{{count}} sessions will be archived.",
  "workspace.reset.note":
    "This resets the OpenAnalyst workspace to the project baseline. Local uncommitted changes may be lost.",
}
